// extracted by mini-css-extract-plugin
module.exports = {"modal":"AlertSimple-module_modal_2H_7W","body":"AlertSimple-module_body_3nxmL"};